import AssociateRatesToReferenceContainer from './AssociateRatesToReferenceContainer';

export default { AssociateRatesToReferenceContainer };
